import React from 'react';
import PropTypes from 'prop-types';
import UamMessagePanel from '../UamMessagePanel/UamMessagePanel';

const EmailPendingPanel = ({ email }) => (
  <UamMessagePanel
    header="Check Your Email to Continue Registration"
  >
    An email has been sent to {email}. Click the button in the email to {' '}
    to confirm your email address and resume your registration.
  </UamMessagePanel>
);

EmailPendingPanel.propTypes = {
  email: PropTypes.string.isRequired,
};

export default EmailPendingPanel;
